const XTZJ_INSTALLER_PREFIX = 'DClaw_Setup_xtzj'
const XTZJ_INSTALLER_DISPLAY_NAME = 'DClaw_Setup_xtzj.exe'

export function formatInstallerDisplayName(installerName) {
  const text = String(installerName || '').trim()
  if (!text) return ''

  if (text.startsWith(XTZJ_INSTALLER_PREFIX)) {
    return XTZJ_INSTALLER_DISPLAY_NAME
  }

  return text
}
